module.exports = __webpack_public_path__ + "static/media/Barack H. Obama - 2012.f8dad108.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Barack H. Obama - 2012.jpg
// module id = 442
// module chunks = 0